import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import URL from 'url-parse';
import type { Primitive } from 'utility-types';

import { call } from '@swf/core/api/embedded';
import type { ResolverTag } from '@swf/core/enums';
import useResolver from '@swf/core/hooks/useResolver';
import { select } from '@swf/core/store';

export type Query = Record<string, Primitive>;

interface Props {
  resolverTag: ResolverTag;
  query?: Query;
  openTab?: boolean;
}

const useOpenWindow = ({ query, openTab, resolverTag }: Props) => {
  const resolvedUrl = useResolver(resolverTag);
  const locale = useSelector(select.locale.get);
  const embedded = useSelector(select.site.isEmbedded);

  const openWindow = useCallback(() => {
    const parsed = new URL(resolvedUrl, true);
    parsed.query.language = locale;
    Object.assign(parsed.query, query);
    const options = openTab ? ['_blank'] : [resolverTag, 'scrollbars=yes,resizable=no'];
    const url = parsed.toString();

    return embedded ? call(['app', 'open'], url) : window.open(url, ...options);
  }, [resolvedUrl, locale, query, openTab, resolverTag, embedded]);

  return openWindow;
};

export default useOpenWindow;
